export const newDealLink = {
    to: '/deal-registration',
    text: 'New Deal'
}
